import {Component} from 'argo-js/src/view';
import {Utils} from 'argo-js/src/common/Utils';

const VERIFY_PARAM = 'eid';

export class VerifyEmail extends Component {

  constructor(config) {
    super({
      ui: {
        loading: '.js-loading',
        success: '.status-success',
        error: '.status-error',
        errorText: '.error-text'
      }
    }, config);
  }

  onInit() {
    let query = Utils.getQueryParams();
    this.token = query[VERIFY_PARAM] || null;
    if (!this.token) {
      this.showError();
    }
    else {
      this.app.user.verifyEmailAddressByToken(this.token)
          .then(this.showSuccess.bind(this))
          .catch(this.handleError.bind(this));
    }
  }

  handleError(resp) {
    let message = resp.message;
    if (resp.status === 404) {
      message = this.t('verifyNewEmail.tokenNotFound');
    }

    this.showError(message);
  }

  showError(msg = null) {
    if (msg) {
      this.ui.errorText.text(msg);
    }
    this.ui.loading.hide();
    this.ui.error.fadeIn(500);
  }

  showSuccess() {
    this.ui.loading.hide();
    this.ui.success.fadeIn(500);

    setTimeout(() => {
      this.app.toHome();
    }, 1000);
  }

}